import { render, staticRenderFns } from "./ShareReservations.vue?vue&type=template&id=7f233164"
import script from "./ShareReservations.vue?vue&type=script&lang=js"
export * from "./ShareReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports